import ApiService from "@/core/services/api.service";

// action types
export const FETCH_ADMIN_REPORTS = "fetchAdminReports";
export const STORE_ADMIN_TRANSACTION = "storeAdminReports";

// mutation types
export const SET_ADMIN_REPORTS = "setAdminReports";
export const SET_ADMIN_REPORTS_PAGINATION = "setAdminReportsPagination";

const state = {
  adminReports: [],
  adminReportsPagination: {
    total: 0,
    currentPage: 1,
    firstPage: 1,
    lastPage: 1,
    perPage: 0
  },
  sort: {
    col: "id",
    dir: "desc"
  },
  reportTypes: {
    1: "محتوای دلخراش و آزارد دهنده",
    2: "محتوای تحریک آمیز جنسی",
    3: "توهین به قومیت ها / محتوای نژاد پرستی",
    4: "توهین به اقلیت های مذهبی",
    5: "اهانت به مقامات سیاسی",
    6: "اشاعه خشونت در جامعه",
    7: "اشاعه کودک آزاری",
    8: "قلدری و تهدید دیگران",
    9: "محتوای نامناسب برای کودکان",
    10: "عدم رعایت حق نشر",
    11: "استفاده تبلیغاتی غیر مجاز",
    12: "حیوان آزاری",
    13: "سایر موارد"
  }
};

const getters = {
  adminReports(state) {
    return state.adminReports;
  },
  adminReportsPagination(state) {
    return state.adminReportsPagination;
  },
  reportTypes(state) {
    return state.reportTypes;
  }
};

const actions = {
  [FETCH_ADMIN_REPORTS](context) {
    let params = {
      page: context.state.adminReportsPagination.currentPage
    };
    return new Promise((resolve, reject) => {
      ApiService.query("admin/reports", {
        params: params
      })
        .then(({ data }) => {
          context.commit(SET_ADMIN_REPORTS, data.data);
          context.commit(SET_ADMIN_REPORTS_PAGINATION, {
            total: data["total"],
            currentPage: data["current_page"],
            firstPage: data["first_page"],
            lastPage: data["last_page"],
            perPage: data["per_page"]
          });
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  }
};

const mutations = {
  [SET_ADMIN_REPORTS](state, data) {
    state.adminReports = data;
  },
  [SET_ADMIN_REPORTS_PAGINATION](state, data) {
    state.adminReportsPagination = data;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
